import React from 'react';

type OwnProps = {
  className?: string;
};

const RightArrow = ({ className }: OwnProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="14"
    viewBox="0 0 9 14"
    className={className}
  >
    <g>
      <g>
        <path d="M1.227 13.993c.295 0 .591-.106.824-.319l6.555-6.009c.25-.23.392-.557.385-.895a1.187 1.187 0 0 0-.418-.881L2.02.29A1.22 1.22 0 0 0 .312.41a1.182 1.182 0 0 0 .122 1.683l5.534 4.729-5.565 5.104a1.179 1.179 0 0 0-.063 1.686c.239.254.562.381.887.381" />
      </g>
    </g>
  </svg>
);

export default RightArrow;
